export class MockAnalyticsProvider {
    constructor() {
        this.events = [];
    }
    logEvent(name, params) {
        this.events.push({ name, params, timestamp: Date.now() });
    }
    setUserProperty(_key, _value) { }
    reset() {
        this.events.length = 0;
    }
}
